namespace GeniuzPOS.Purchase {
    export interface ReportDailyCNRow {
        Id?: string;
        SysDocNo?: string;
        CreditNoteNo?: string;
        DocDate?: string;
        SupplierId?: string;
        SupplName?: string;
        RefDocNo1?: string;
        PayTermCode?: string;
        DueDate?: string;
        WhsId?: string;
        TotalAmt?: number;
        DiscAmt?: number;
        NetAmt?: number;
        VatAmt?: number;
        ExciseTaxAmt?: number;
        CreditNoteAmt?: number;
        DepositAmt?: number;
    }

    export namespace ReportDailyCNRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Purchase.ReportDailyCN';
        export const lookupKey = 'Purchase.ReportDailyCN';

        export function getLookup(): Q.Lookup<ReportDailyCNRow> {
            return Q.getLookup<ReportDailyCNRow>('Purchase.ReportDailyCN');
        }
        export const deletePermission = '5Purchase:รายงาน:รายงานใบลดหนี้ซื้อ:View';
        export const insertPermission = '5Purchase:รายงาน:รายงานใบลดหนี้ซื้อ:View';
        export const readPermission = '5Purchase:รายงาน:รายงานใบลดหนี้ซื้อ:View';
        export const updatePermission = '5Purchase:รายงาน:รายงานใบลดหนี้ซื้อ:View';

        export declare const enum Fields {
            Id = "Id",
            SysDocNo = "SysDocNo",
            CreditNoteNo = "CreditNoteNo",
            DocDate = "DocDate",
            SupplierId = "SupplierId",
            SupplName = "SupplName",
            RefDocNo1 = "RefDocNo1",
            PayTermCode = "PayTermCode",
            DueDate = "DueDate",
            WhsId = "WhsId",
            TotalAmt = "TotalAmt",
            DiscAmt = "DiscAmt",
            NetAmt = "NetAmt",
            VatAmt = "VatAmt",
            ExciseTaxAmt = "ExciseTaxAmt",
            CreditNoteAmt = "CreditNoteAmt",
            DepositAmt = "DepositAmt"
        }
    }
}
